<template>
  <v-form v-bind="this.$attrs">
    <div class="wrap_filter">
      <v-row class="mb-0">
        <v-col cols="12">
          <GradeClassStudentSelect
            @changed="gradeClassStudentChange"
            :disableGradeSelect="user.role.type === 'teacher'"
            :autoSyncClassByStudent="false"
            :autoSyncGradeByClass="false"
          />
        </v-col>
      </v-row>
      <div class="buttonSearch ml-6 mt-2 d-flex justify-end align-end">
        <v-btn class="search-button" height="40" outlined @click="onFilterChanged"> Tìm kiếm </v-btn>
      </div>
    </div>
  </v-form>
</template>

<script>
import { get } from 'lodash'
import { mapState, mapGetters } from 'vuex'
import GradeClassStudentSelect from '@/components/basic/filter/GradeClassStudentSelect.vue'
// TODO: filter with teacher
export default {
  props: {
    viewIsPaid: Boolean
  },
  components: {
    GradeClassStudentSelect
  },
  data() {
    return {
      classData: null,
      grade: null,
      student: null,
      useNote: null
    }
  },

  computed: {
    ...mapGetters('auth', ['user']),
    ...mapState('constant', ['attendanceStatus']),
    gradeId() {
      return { grade: get(this.grade, 'id') }
    },
    currentClassId() {
      return { currentClass: get(this.classData, 'id') }
    }
  },
  methods: {
    gradeClassStudentChange(data) {
      this.grade = data.grade
      this.classData = data.class
      this.student = data.student
    },
    async onFilterChanged() {
      let query = {
        grade: get(this.grade, 'id'),
        class: get(this.classData, 'id'),
        student: get(this.student, 'id')
      }
      this.$emit('onFilter', query)
    }
  }
}
</script>
<style lang="scss" scoped>
@media screen and (max-width: 960px) {
  .wrap_filter {
    display: block;
  }
  div.buttonSearch {
    padding-top: 24px;
    margin-left: 0px !important;
  }
}
</style>
